import layout from "./layout/LayoutConfig";

const themeLayoutConfigs = {
  layout,
};

export default themeLayoutConfigs;
